"use client"

import * as React from "react"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"

import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "@/components/ui/popover"
import { cn } from "@/lib/utils"
import { format } from "date-fns"
import { Label } from "./ui/label"
import { Input } from "./ui/input"

export function DatePicker({ dateValue, setDate, time, className }: { dateValue?: string; setDate: React.Dispatch<React.SetStateAction<string>>, time?: boolean, className: string }) {
	const [open, setOpen] = React.useState(false)
	const [xDate, setXDate] = React.useState<Date | undefined>(dateValue ? new Date(dateValue) : undefined)

	function handleDateChange(date: Date) {
		setXDate(date);
		const dateFormat = time ? 'y-MM-dd hh:mm:ss aa' : 'y-MM-dd';
		setDate(format(new Date(date), dateFormat));
	}

	return (
		<div className={cn('', className, !!time && 'flex gap-4')}>
			<div className={cn('', !!time && 'flex flex-1 flex-col gap-3')}>
				{
					!!time && (
						<Label htmlFor="date-picker" className="px-1">
							Date
						</Label>
					)
				}
				<Popover open={open} onOpenChange={setOpen}>
					<PopoverTrigger asChild>
						<Button
							variant="outline"
							id="date"
							className="w-full justify-between font-normal"
						>
							{xDate ? (new Date(xDate)).toLocaleDateString() : "Select date"}
							{/* <ChevronDownIcon /> */}
						</Button>
					</PopoverTrigger>
					<PopoverContent className="overflow-hidden p-0" align="start">
						<Calendar
							mode="single"
							className="w-full"
							selected={xDate}
							captionLayout="dropdown"
							onSelect={(date) => {
								handleDateChange(date as Date)
								setOpen(false)
							}}
						/>
					</PopoverContent>
				</Popover>
			</div>
			{
				!!time && (
					<div className="flex flex-1 flex-col gap-3">
						<Label htmlFor="time-picker" className="px-1">
							Time
						</Label>
						<Input
							type="time"
							id="time-picker"
							step="1"
							defaultValue="00:00:00"
							className="bg-background appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none"
							onChange={(e) => handleDateChange(new Date(xDate?.toDateString() + " " + e.target.value))}
						/>
					</div>
				)
			}
		</div>
	)
}
